import { lazy, Suspense } from 'react';

import { LoadingIndicator } from '@bambi/component-library/src/components/LoadingIndicator/LoadingIndicator';
import { RouteObject } from 'react-router';

import { DefaultErrorElement } from 'src/app/DefaultErrorElement';
import { NotFoundChildRoute } from 'src/app/NotFoundChildRoute';

const ReportsOverviewRoute = lazy(() =>
  import('./ReportsOverviewRoute/ReportsOverviewRoute').then((module) => ({
    default: module.ReportsOverviewRoute,
  }))
);

const DriverReportsRoute = lazy(() =>
  import('./DriverReportsRoute/DriverReportsRoute').then((module) => ({
    default: module.DriverReportsRoute,
  }))
);

const PayerReportsRoute = lazy(() =>
  import('./PayerReportsRoute/PayerReportsRoute').then((module) => ({
    default: module.PayerReportsRoute,
  }))
);

export const reportsRoutes: RouteObject[] = [
  {
    index: true,
    element: (
      <Suspense fallback={<LoadingIndicator />}>
        <ReportsOverviewRoute />
      </Suspense>
    ),
    errorElement: <DefaultErrorElement />,
  },
  {
    path: 'drivers',
    element: (
      <Suspense fallback={<LoadingIndicator />}>
        <DriverReportsRoute />
      </Suspense>
    ),
  },
  {
    path: 'payers',
    element: (
      <Suspense fallback={<LoadingIndicator />}>
        <PayerReportsRoute />
      </Suspense>
    ),
  },
  {
    path: '*',
    element: (
      <NotFoundChildRoute routePath="/reports" linkText="Go back to reports" />
    ),
  },
];
